
/**
 * Representa o status de carregamento do gráfico de linhas das chuvas
 */
export enum Status {
  LOADING,
  SUCCESS
}